/**
 * @fileoverview GET handler for the "/engagement/campaign_banner_click_daily_stats/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignBannerClickDailyStatsCampaignId } from "./constants";
import type {
  EngagementCampaignBannerClickDailyStatsCampaignIdParams,
  EngagementCampaignBannerClickDailyStatsCampaignIdResult,
} from "./types";

export const getEngagementCampaignBannerClickDailyStatsCampaignId = reactQueryFetcherAdapter(
  engagementCampaignBannerClickDailyStatsCampaignId,
  (
    signal: AbortSignal,
    { campaignId, appGroupId, startDate, endDate }: EngagementCampaignBannerClickDailyStatsCampaignIdParams
  ): Promise<EngagementCampaignBannerClickDailyStatsCampaignIdResult> => {
    return fetch(
      `/engagement/campaign_banner_click_daily_stats/${campaignId}`,
      "GET",
      { app_group_id: appGroupId, start: startDate, end: endDate },
      { signal }
    );
  }
);
